import { UserManager, WebStorageStateStore } from "oidc-client";

import { DefaultAuth } from "./Configuration";

const origin = document.location.origin;

const oidcConfig = {
  // Mandatory Options ( NEVER CHANGE THESE !)
  authority: DefaultAuth,
  client_id: "MG-RJS-SanaCash",
  redirect_uri: `${origin}/authentication/callback`,
  response_type: "id_token token",
  scope: "openid profile WebApiApiScope",

  // Optional Options
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  loadUserInfo: true,
  post_logout_redirect_uri: `${origin}/welcome`,
  silent_redirect_uri: `${origin}/welcome`,
  automaticSilentRenew: false,
  revokeAccessTokenOnSignout: true,
};

export const oidcUserManager = new UserManager(oidcConfig);

export const logout = async () => {
  try {
    // Clear local storage
    localStorage.clear();
    
    // Clear session storage
    sessionStorage.clear();
    
    // Clear cookies
    document.cookie.split(";").forEach(cookie => {
      const name = cookie.split("=")[0];
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
    
    // Clear other storage (IndexedDB, Cache API)
    if (window.indexedDB) {
      indexedDB.databases().then(databases => {
        databases.forEach(db => indexedDB.deleteDatabase(db.name));
      });
    }

    if (window.caches) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    }

    // Sign out using OIDC
    await oidcUserManager.signoutRedirect();
  } catch (e) {
    throw e;
  }
};

export const login = async () => {
  try {
    const keepKey = 'is-updated-v3';
    const keepValue = localStorage.getItem(keepKey);
    localStorage.clear();
    if (keepValue !== null) {
      localStorage.setItem(keepKey, keepValue);
    }
    
    document.cookie =
      "username=;expires=Fri, 07 Jun 2019 00:00:00 UTC; pach=/;";
    oidcUserManager.signinRedirect();
  } catch (e) {
    throw e;
  }
};

export const silentAuthenticate = async () => {
  try {
    oidcUserManager.signinSilent();
  } catch (e) {
    throw e;
  }
};

// METHODS THAT CAN BE USED FROM oidcUserManager
//
// getUser: Returns promise to load the User object for the currently authenticated user.
// removeUser: Returns promise to remove from any storage the currently authenticated user.
// signinRedirect: Returns promise to trigger a redirect of the current window to the authorization endpoint.
// signinRedirectCallback: Returns promise to process response from the authorization endpoint. The result of the promise is the authenticated User.
// signinSilent: Returns promise to trigger a silent request (via an iframe) to the authorization endpoint. The result of the promise is the authenticated User.
// signinSilentCallback: Returns promise to notify the parent window of response from the authorization endpoint.
// signinPopup: Returns promise to trigger a request (via a popup window) to the authorization endpoint. The result of the promise is the authenticated User.
// signinPopupCallback: Returns promise to notify the opening window of response from the authorization endpoint.
// signoutRedirect: Returns promise to trigger a redirect of the current window to the end session endpoint.
// signoutRedirectCallback: Returns promise to process response from the end session endpoint.
// signoutPopup [1.4.0]: Returns promise to trigger a redirect of a popup window window to the end session endpoint.
// signoutPopupCallback [1.4.0]: Returns promise to process response from the end session endpoint from a popup window.
// querySessionStatus [1.1.0]: Returns promise to query OP for user's current signin status. Returns object with session_state and subject identifier.
// startSilentRenew [1.4.0]: Enables silent renew for the UserManager.
// stopSilentRenew [1.4.0]: Disables silent renew for the UserManager.
// clearStaleState: Removes stale state entries in storage for incomplete authorize requests.
